
import React from "react";
import { 
  Sidebar, 
  SidebarContent as SidebarContentComponent,
  useSidebar
} from "@/components/ui/sidebar";
import { ScrollArea } from "@/components/ui/scroll-area";
import SidebarHeader from "./SidebarHeader";
import SidebarContentSection from "./SidebarContentSection";
import SidebarBoardsSection from "./SidebarBoardsSection";
import SidebarTagsSection from "./SidebarTagsSection";
import SidebarFooterSection from "./SidebarFooterSection";
import SidebarDeleteContentSection from "./SidebarDeleteContentSection";
import EditCollectionDialog from "@/components/common/EditCollectionDialog";
import DeleteCollectionDialog from "@/components/common/DeleteCollectionDialog";
import EditBoardDialog from "@/components/boards/EditBoardDialog";
import DeleteBoardDialog from "@/components/boards/DeleteBoardDialog";

// Separate dialog component to avoid re-renders
const DialogsContainer = () => {
  console.log("Rendering DialogsContainer for collection and board dialogs");
  return (
    <>
      <EditCollectionDialog />
      <DeleteCollectionDialog />
      <EditBoardDialog />
      <DeleteBoardDialog />
    </>
  );
};

// Main sidebar content component
const SidebarContentWrapper = () => {
  // Add debugging log to show that component is rendering and using sidebar context
  const { openMobile, setOpenMobile } = useSidebar();
  
  React.useEffect(() => {
    console.log("SidebarContentWrapper rendered with openMobile state:", openMobile);
  }, [openMobile]);

  return (
    <>
      <Sidebar className="border-r border-border bg-background dark:bg-card">
        <SidebarHeader />
        
        <SidebarContentComponent className="p-0">
          <ScrollArea className="h-[calc(100vh-144px)] px-3">
            {/* No padding in this container - spacing is handled within the sections */}
            <div>
              <SidebarContentSection />
              <div className="h-6"></div> {/* 24px space between Collections and Tags */}
              <SidebarTagsSection />
              <div className="h-6"></div> {/* 24px space between Tags and Boards */}
              <SidebarBoardsSection />
              <div className="h-6"></div> {/* 24px space between Boards and Delete Content */}
              <SidebarDeleteContentSection />
            </div>
          </ScrollArea>
        </SidebarContentComponent>
        
        <SidebarFooterSection />
      </Sidebar>
    </>
  );
};

// Export the component without wrapping it in another SidebarProvider
const AppSidebar = () => {
  return (
    <>
      <SidebarContentWrapper />
      <DialogsContainer />
    </>
  );
};

export default AppSidebar;
